// Port of api/fuel/app/classes/controller/api/monty/listing/add.php
import {
	LIST_TYPE_MANUAL,
	currentEdition,
	currentUserId,
	loadListingEdition,
	loadOwnedListing,
	parseGameIndex,
	persist,
	saveEditionGames,
	unauthorised,
	uniqueIndex
} from './shared'

export default function(params) {
	var userId = currentUserId(params)
	var listing = loadOwnedListing(userId, params.list)
	var edition = null
	var games = uniqueIndex(params.games || [])
	var index = []
	var seen = {}
	var i = 0

	if (!userId) return unauthorised()
	if (!listing || listing.get_type() !== LIST_TYPE_MANUAL) return unauthorised()

	edition = loadListingEdition(listing, params.edition) || currentEdition(listing)
	if (!edition) return Promise.reject({ error: 120, offline: true })

	index = parseGameIndex(edition.get_index_games())
	for (i = 0; i < index.length; i++) seen[index[i]] = true
	for (i = 0; i < games.length; i++) {
		if (!seen[games[i]]) index.push(games[i])
	}

	saveEditionGames(edition.get_id(), index)
	return persist({})
}
